import { create } from 'zustand';
import { useLive } from './live';

/** The thread open next to (or, on narrow screens, instead of) its channel's chat (docs/plans/2026-11-04-threads-design.md). */
export const useThreadPanel = create<{ open: { channelId: string; rootId: string } | null; page: boolean }>(() => ({ open: null, page: false }));

/** Opens a thread, in its channel. */
export function openThread(channelId: string, rootId: string) {
  if (useLive.getState().selectedChannelId !== channelId) useLive.getState().select(channelId);
  useThreadPanel.setState({ open: { channelId, rootId }, page: false });
}

/** The "Dallar" page in the main area, in place of a channel. */
export function showThreadsPage() {
  useLive.getState().select(null);
  useThreadPanel.setState({ page: true });
}
export const hideThreadsPage = () => useThreadPanel.setState({ page: false });

// Picking a channel leaves the "Dallar" page.
useLive.subscribe((state, previous) => {
  if (state.selectedChannelId && state.selectedChannelId !== previous.selectedChannelId && useThreadPanel.getState().page) hideThreadsPage();
});

export const closeThreadPanel = () => useThreadPanel.setState({ open: null });
